import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';
import { themeModule } from './modules/theme';
import { portalPlugin } from './modules/portal';
import { homePlugin } from './modules/home';
import { marketplacePlugin } from './modules/marketplace';
import { breadcrumbsModule } from './modules/breadcrumbs';
import { templatesModule } from './modules/templates';
import { entityOverviewModule } from './modules/entity-overview';
import { analyticsModule } from './modules/analytics';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    authModule,
    themeModule,
    portalPlugin,
    homePlugin,
    marketplacePlugin,
    breadcrumbsModule,
    templatesModule,
    entityOverviewModule,
    analyticsModule,
  ],
});
